export default {
    serviceGroups: 'service Groups',
    serviceGroupsTitle: 'Title',
    serviceGroupsStatus: 'Status',
    editServiceGroups: 'Edit service Groups',
    addServiceGroups: ' New service Groups',

}